// // ProductLabel.jsx
// import React from 'react';
// import Barcode from 'react-barcode';

// /**
//  * A reusable component to generate a product label including MRP, attributes, and barcode.
//  * @param {object} props.variant - The entire variant object containing all data.
//  */
// const ProductLabel = ({ variant }) => {
//     // Safely destructure required data
//     const barcodeData = variant?.barcode_number;
//     const mrp = variant?.product_item_mrp;
//     const size = variant?.size_name;
//     const color = variant?.color_name;
//     const sku = variant?.product_item_id;

//     if (!barcodeData) {
//         return <span className="text-red-500 text-xs">No Barcode Data</span>;
//     }

//     // Format MRP for display
//     const formattedMrp = mrp ? `MRP: ₹${parseFloat(mrp).toFixed(2)}` : 'MRP: N/A';
    
//     // Format attributes string
//     let attributes = [];
//     if (size) attributes.push(`Size: ${size}`);
//     if (color) attributes.push(`Color: ${color}`);
//     const attributesText = attributes.join(' | ');

//     return (
//         <div className="product-label-print-area ml-4">
//             {/* 1. Attributes and SKU */}
//             <div className="text-xs font-medium text-gray-800 text-center mb-0.5" style={{ fontSize: '9px' }}>
//                 {/* {sku && <div>SKU: {sku}</div>} */}
//                 {attributesText && <div>{attributesText}</div>}
//             </div>

//             {/* 2. MRP */}
//             <div className="text-lg font-bold text-gray-900 text-center mb-0.5" style={{ fontSize: '11px' }}>
//                 {formattedMrp}
//             </div>
            
//             {/* 3. Barcode */}
//             <Barcode
//                 value={String(barcodeData)}
//                 format="CODE128"
//                 displayValue={true}
//                 text={String(barcodeData)}
//                 fontSize={10}
                
//                             width={1.3} // Slightly narrower to guarantee it fits inside the new margins
//                             height={45}
//                             margin={0}
//                             lineColor="#000000"
//             />
//         </div>
//     );
// };

// export default ProductLabel;

// ProductLabel.jsx
// import React from 'react';
// import Barcode from 'react-barcode';

// const ProductLabel = ({ variant }) => {
//     const barcodeData = variant?.barcode_number;
//     const mrp = variant?.product_item_mrp;
//     const size = variant?.size_name;
//     const color = variant?.color_name;

//     if (!barcodeData) {
//         return <span className="text-red-500 text-xs">No Barcode Data</span>;
//     }

//     const formattedMrp = mrp ? `MRP: ₹${parseFloat(mrp).toFixed(2)}` : 'MRP: N/A';
    
//     let attributes = [];
//     if (size) attributes.push(`${size}`);
//     if (color) attributes.push(`${color}`);
//     const attributesText = attributes.join(' / ');

//     return (
//         <div 
//             className="product-label-container" 
//             style={{ 
//                 width: '2in', 
//                 height: '1in', 
//                 padding: '2mm',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 backgroundColor: 'white',
//                 overflow: 'hidden',
//                 boxSizing: 'border-box'
//             }}
//         >
//             {/* 1. Attributes - Kept small to save vertical space */}
//             <div style={{ fontSize: '8px', fontWeight: '600', marginBottom: '1px', textAlign: 'center', lineHeight: '1' }}>
//                 {attributesText}
//             </div>

//             {/* 2. MRP - Bold for visibility */}
//             <div style={{ fontSize: '10px', fontWeight: 'bold', marginBottom: '2px', textAlign: 'center' }}>
//                 {formattedMrp}
//             </div>
            
//             {/* 3. Barcode - Optimized for 2x1 */}
//             <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
//                 <Barcode
//                     value={String(barcodeData)}
//                     format="CODE128"
//                     displayValue={true}
//                     fontSize={8}
//                     margin={0}
//                     background="transparent"
//                     /* Width 1.2 ensures the bars don't bleed off the edge on a 2" label */
//                     width={1.2} 
//                     /* Height 30-35 leaves enough room for the text above */
//                     height={35}
//                     lineColor="#000000"
//                 />
//             </div>

//             {/* Print CSS to handle the 2x1 dimensions at the browser level */}
//             <style dangerouslySetInnerHTML={{ __html: `
//                 @media print {
//                     @page {
//                         size: 2in 1in;
//                         margin: 0;
//                     }
//                     body {
//                         margin: 0;
//                         -webkit-print-color-adjust: exact;
//                     }
//                     .product-label-container {
//                         page-break-inside: avoid;
//                         page-break-after: always;
//                     }
//                 }
//             `}} />
//         </div>
//     );
// };

// export default ProductLabel;

// ProductLabel.jsx
import React from 'react';
import Barcode from 'react-barcode';
import logo from '../assets/logo2.jpg';

const ProductLabel = ({ variant }) => {
    const barcodeData = variant?.barcode_number;
    const mrp = variant?.product_item_mrp;
    const size = variant?.size_name;
    const color = variant?.color_name;

    if (!barcodeData) {
        return <span className="text-red-500 text-xs">No Barcode Data</span>;
    }

    const formattedMrp = mrp ? `₹${parseFloat(mrp).toFixed(0)}` : 'N/A';
    
    let attributes = [];
    if (size) attributes.push(`${size}`);
    if (color) attributes.push(`${color}`);
    const attributesText = attributes.join(' / ');

    return (
        <div 
            className="product-label-container" 
            style={{ 
                width: '2in', 
                height: '1in', 
                padding: '1mm 2mm',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'white',
                overflow: 'hidden',
                boxSizing: 'border-box',
                fontFamily: 'Arial, sans-serif'
            }}
        >
            {/* 1. Header Row: Logo and MRP side-by-side */}
            <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                width: '100%',
                marginBottom: '1px'
            }}>
                <img 
                    src={logo} 
                    alt="Logo" 
                    style={{ 
                        height: '22px', 
                        maxWidth: '80px',
                        objectFit: 'contain',
                        filter: 'grayscale(100%) contrast(150%)'
                    }} 
                />
                <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '7px', fontWeight: 'normal', lineHeight: '1' }}>MRP</div>
                    <div style={{ fontSize: '11px', fontWeight: 'bold', lineHeight: '1' }}>{formattedMrp}</div>
                </div>
            </div>

            {/* 2. Attributes Row */}
            <div style={{ 
                fontSize: '8px', 
                fontWeight: '600', 
                textAlign: 'center', 
                borderTop: '0.5px solid #000', 
                paddingTop: '1px',
                marginBottom: '2px' 
            }}>
                {attributesText}
            </div>
            
            {/* 3. Barcode Section - Height restored to 35px */}
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center',
                width: '100%', 
                marginTop: 'auto' 
            }}>
                <Barcode
                    value={String(barcodeData)}
                    format="CODE128"
                    displayValue={true}
                    fontSize={8}
                    margin={0}
                    width={1.2} 
                    height={35}
                    lineColor="#000000"
                />
            </div>

            <style dangerouslySetInnerHTML={{ __html: `
                @media print {
                    @page { size: 2in 1in; margin: 0; }
                    body { margin: 0; }
                    .product-label-container { page-break-inside: avoid; page-break-after: always; }
                }
            `}} />
        </div>
    );
};

export default ProductLabel;